import { TranslateModule } from '@ngx-translate/core';

import { HTTP_INTERCEPTORS, HttpClientModule } from '@angular/common/http';
import { ModuleWithProviders, NgModule } from '@angular/core';

import {
  AggHttpService,
  HTTP_CONFIG,
  MwHttpConfigService,
  MwHttpService,
} from '../http/services';
import { MwHttpDateInterceptor, NotFoundInterceptor } from './interceptors';
import { MwUrlService } from './services/url.service';
import { HttpConfig } from './types';

@NgModule({
  imports: [HttpClientModule, TranslateModule],
  providers: [AggHttpService, MwHttpService, MwHttpConfigService, MwUrlService],
})
export class MwHttpModule {
  static forRoot(config: HttpConfig): ModuleWithProviders<MwHttpModule> {
    return {
      ngModule: MwHttpModule,
      providers: [
        {
          provide: HTTP_CONFIG,
          useValue: config,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: MwHttpDateInterceptor,
          multi: true,
        },
        {
          provide: HTTP_INTERCEPTORS,
          useClass: NotFoundInterceptor,
          multi: true,
        },
      ],
    };
  }
}
